var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2119_23030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 29.1855C17.4836 29.1568 18.1016 29.1258 18.7196 29.0925C19.2386 25.9835 19.9577 22.9605 20.9275 20.1428C22.0234 17.0051 23.5057 14.1564 25.4636 12.2703C26.5889 11.0818 25.6601 8.44653 24.4168 9.30353C19.5655 12.8864 16.4346 21.1203 14.6387 29.3518C15.382 29.2692 16.126 29.2199 16.8649 29.1843L16.8642 29.1855Z",
    fill: "#D1EAAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52627 5.3146C7.74815 4.40712 8.95328 8.1575 9.61376 10.9763C10.706 15.8498 11.0711 21.1295 11.2712 26.3002C11.3115 27.5117 11.3401 28.7806 11.3416 30.0001C12.7908 29.5607 14.2752 29.3588 15.7516 29.2509C15.7106 28.7175 15.6578 28.1071 15.6219 27.6861C14.9137 20.3161 13.1441 5.1253 8.25175 2.0759C7.19323 1.39557 5.92138 1.46556 4.88338 2.0736C3.59908 2.86291 4.17965 5.80104 5.52627 5.3146Z",
    fill: "#D1EAAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2119_23030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant1);
export default __webpack_public_path__ + "static/media/plant-1.7e02fe61fd5756451a26aadde759f638.svg";
export { ForwardRef as ReactComponent };